import { Document as Document$1 } from "../newsdoc/newsdoc.mjs";
import { ServiceType, stackIntercept } from "@protobuf-ts/runtime-rpc";
import { MessageType, UnknownFieldHandler, WireType, reflectionMergePartial } from "@protobuf-ts/runtime";
//#region src/user/service.ts
/**
* @generated from protobuf enum elephant.user.EventLogEntryType
*/
let EventLogEntryType = /* @__PURE__ */ function(EventLogEntryType) {
	/**
	* @generated from protobuf enum value: EVENT_LOG_ENTRY_UNSPECIFIED = 0;
	*/
	EventLogEntryType[EventLogEntryType["EVENT_LOG_ENTRY_UNSPECIFIED"] = 0] = "EVENT_LOG_ENTRY_UNSPECIFIED";
	/**
	* @generated from protobuf enum value: EVENT_LOG_ENTRY_UPDATE = 1;
	*/
	EventLogEntryType[EventLogEntryType["EVENT_LOG_ENTRY_UPDATE"] = 1] = "EVENT_LOG_ENTRY_UPDATE";
	/**
	* @generated from protobuf enum value: EVENT_LOG_ENTRY_DELETE = 2;
	*/
	EventLogEntryType[EventLogEntryType["EVENT_LOG_ENTRY_DELETE"] = 2] = "EVENT_LOG_ENTRY_DELETE";
	return EventLogEntryType;
}({});
/**
* @generated from protobuf enum elephant.user.ResourceKind
*/
let ResourceKind = /* @__PURE__ */ function(ResourceKind) {
	/**
	* @generated from protobuf enum value: RESOURCE_KIND_UNSPECIFIED = 0;
	*/
	ResourceKind[ResourceKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
	/**
	* @generated from protobuf enum value: RESOURCE_KIND_DOCUMENT = 1;
	*/
	ResourceKind[ResourceKind["DOCUMENT"] = 1] = "DOCUMENT";
	/**
	* @generated from protobuf enum value: RESOURCE_KIND_PROPERTY = 2;
	*/
	ResourceKind[ResourceKind["PROPERTY"] = 2] = "PROPERTY";
	return ResourceKind;
}({});
/**
* SchemaUsage declares what a schema is used for. The values mirror the
* ecosystem-wide schema usage categorisation; the user service only
* accepts SCHEMA_USAGE_SETTINGS and SCHEMA_USAGE_MESSAGES.
*
* @generated from protobuf enum elephant.user.SchemaUsage
*/
let SchemaUsage = /* @__PURE__ */ function(SchemaUsage) {
	/**
	* @generated from protobuf enum value: SCHEMA_USAGE_UNSPECIFIED = 0;
	*/
	SchemaUsage[SchemaUsage["UNSPECIFIED"] = 0] = "UNSPECIFIED";
	/**
	* @generated from protobuf enum value: SCHEMA_USAGE_EDITORIAL = 1;
	*/
	SchemaUsage[SchemaUsage["EDITORIAL"] = 1] = "EDITORIAL";
	/**
	* @generated from protobuf enum value: SCHEMA_USAGE_DISTRIBUTION = 2;
	*/
	SchemaUsage[SchemaUsage["DISTRIBUTION"] = 2] = "DISTRIBUTION";
	/**
	* @generated from protobuf enum value: SCHEMA_USAGE_SETTINGS = 3;
	*/
	SchemaUsage[SchemaUsage["SETTINGS"] = 3] = "SETTINGS";
	/**
	* @generated from protobuf enum value: SCHEMA_USAGE_MESSAGES = 4;
	*/
	SchemaUsage[SchemaUsage["MESSAGES"] = 4] = "MESSAGES";
	return SchemaUsage;
}({});
var GetDocumentRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetDocumentRequest", [
			{
				no: 1,
				name: "owner",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "key",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.owner = "";
		message.application = "";
		message.type = "";
		message.key = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.owner = reader.string();
					break;
				case 2:
					message.application = reader.string();
					break;
				case 3:
					message.type = reader.string();
					break;
				case 4:
					message.key = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.owner !== "") writer.tag(1, WireType.LengthDelimited).string(message.owner);
		if (message.application !== "") writer.tag(2, WireType.LengthDelimited).string(message.application);
		if (message.type !== "") writer.tag(3, WireType.LengthDelimited).string(message.type);
		if (message.key !== "") writer.tag(4, WireType.LengthDelimited).string(message.key);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetDocumentRequest
*/
const GetDocumentRequest = new GetDocumentRequest$Type();
var GetDocumentResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetDocumentResponse", [{
			no: 1,
			name: "document",
			kind: "message",
			T: () => Document
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetDocumentResponse
*/
const GetDocumentResponse = new GetDocumentResponse$Type();
var Document$Type = class extends MessageType {
	constructor() {
		super("elephant.user.Document", [
			{
				no: 1,
				name: "owner",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "key",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 6,
				name: "schema_version",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "read_only",
				kind: "scalar",
				T: 8
			},
			{
				no: 8,
				name: "title",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "updated",
				kind: "scalar",
				T: 9
			},
			{
				no: 11,
				name: "updated_by",
				kind: "scalar",
				T: 9
			},
			{
				no: 12,
				name: "payload",
				kind: "message",
				T: () => Document$1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.owner = "";
		message.application = "";
		message.type = "";
		message.key = "";
		message.version = 0n;
		message.schemaVersion = "";
		message.readOnly = false;
		message.title = "";
		message.created = "";
		message.updated = "";
		message.updatedBy = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.owner = reader.string();
					break;
				case 2:
					message.application = reader.string();
					break;
				case 3:
					message.type = reader.string();
					break;
				case 4:
					message.key = reader.string();
					break;
				case 5:
					message.version = reader.int64().toBigInt();
					break;
				case 6:
					message.schemaVersion = reader.string();
					break;
				case 7:
					message.readOnly = reader.bool();
					break;
				case 8:
					message.title = reader.string();
					break;
				case 9:
					message.created = reader.string();
					break;
				case 10:
					message.updated = reader.string();
					break;
				case 11:
					message.updatedBy = reader.string();
					break;
				case 12:
					message.payload = Document$1.internalBinaryRead(reader, reader.uint32(), options, message.payload);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.owner !== "") writer.tag(1, WireType.LengthDelimited).string(message.owner);
		if (message.application !== "") writer.tag(2, WireType.LengthDelimited).string(message.application);
		if (message.type !== "") writer.tag(3, WireType.LengthDelimited).string(message.type);
		if (message.key !== "") writer.tag(4, WireType.LengthDelimited).string(message.key);
		if (message.version !== 0n) writer.tag(5, WireType.Varint).int64(message.version);
		if (message.schemaVersion !== "") writer.tag(6, WireType.LengthDelimited).string(message.schemaVersion);
		if (message.readOnly !== false) writer.tag(7, WireType.Varint).bool(message.readOnly);
		if (message.title !== "") writer.tag(8, WireType.LengthDelimited).string(message.title);
		if (message.created !== "") writer.tag(9, WireType.LengthDelimited).string(message.created);
		if (message.updated !== "") writer.tag(10, WireType.LengthDelimited).string(message.updated);
		if (message.updatedBy !== "") writer.tag(11, WireType.LengthDelimited).string(message.updatedBy);
		if (message.payload) Document$1.internalBinaryWrite(message.payload, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.Document
*/
const Document = new Document$Type();
var ListDocumentsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ListDocumentsRequest", [
			{
				no: 1,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "include_payload",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.application = "";
		message.type = "";
		message.includePayload = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.application = reader.string();
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.includePayload = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.application !== "") writer.tag(1, WireType.LengthDelimited).string(message.application);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.includePayload !== false) writer.tag(3, WireType.Varint).bool(message.includePayload);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ListDocumentsRequest
*/
const ListDocumentsRequest = new ListDocumentsRequest$Type();
var ListDocumentsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ListDocumentsResponse", [{
			no: 1,
			name: "documents",
			kind: "message",
			repeat: 2,
			T: () => Document
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.documents = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.documents.push(Document.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.documents.length; i++) Document.internalBinaryWrite(message.documents[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ListDocumentsResponse
*/
const ListDocumentsResponse = new ListDocumentsResponse$Type();
var UpdateDocumentRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.UpdateDocumentRequest", [
			{
				no: 1,
				name: "owner",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "key",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "schema_version",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "payload",
				kind: "message",
				T: () => Document$1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.owner = "";
		message.application = "";
		message.type = "";
		message.key = "";
		message.schemaVersion = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.owner = reader.string();
					break;
				case 2:
					message.application = reader.string();
					break;
				case 3:
					message.type = reader.string();
					break;
				case 4:
					message.key = reader.string();
					break;
				case 5:
					message.schemaVersion = reader.string();
					break;
				case 6:
					message.payload = Document$1.internalBinaryRead(reader, reader.uint32(), options, message.payload);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.owner !== "") writer.tag(1, WireType.LengthDelimited).string(message.owner);
		if (message.application !== "") writer.tag(2, WireType.LengthDelimited).string(message.application);
		if (message.type !== "") writer.tag(3, WireType.LengthDelimited).string(message.type);
		if (message.key !== "") writer.tag(4, WireType.LengthDelimited).string(message.key);
		if (message.schemaVersion !== "") writer.tag(5, WireType.LengthDelimited).string(message.schemaVersion);
		if (message.payload) Document$1.internalBinaryWrite(message.payload, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.UpdateDocumentRequest
*/
const UpdateDocumentRequest = new UpdateDocumentRequest$Type();
var UpdateDocumentResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.UpdateDocumentResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.UpdateDocumentResponse
*/
const UpdateDocumentResponse = new UpdateDocumentResponse$Type();
var DeleteDocumentRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.DeleteDocumentRequest", [
			{
				no: 1,
				name: "owner",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "key",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.owner = "";
		message.application = "";
		message.type = "";
		message.key = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.owner = reader.string();
					break;
				case 2:
					message.application = reader.string();
					break;
				case 3:
					message.type = reader.string();
					break;
				case 4:
					message.key = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.owner !== "") writer.tag(1, WireType.LengthDelimited).string(message.owner);
		if (message.application !== "") writer.tag(2, WireType.LengthDelimited).string(message.application);
		if (message.type !== "") writer.tag(3, WireType.LengthDelimited).string(message.type);
		if (message.key !== "") writer.tag(4, WireType.LengthDelimited).string(message.key);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.DeleteDocumentRequest
*/
const DeleteDocumentRequest = new DeleteDocumentRequest$Type();
var DeleteDocumentResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.DeleteDocumentResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.DeleteDocumentResponse
*/
const DeleteDocumentResponse = new DeleteDocumentResponse$Type();
var Property$Type = class extends MessageType {
	constructor() {
		super("elephant.user.Property", [
			{
				no: 1,
				name: "owner",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "key",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "value",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "updated",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.owner = "";
		message.application = "";
		message.key = "";
		message.value = "";
		message.created = "";
		message.updated = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.owner = reader.string();
					break;
				case 2:
					message.application = reader.string();
					break;
				case 3:
					message.key = reader.string();
					break;
				case 4:
					message.value = reader.string();
					break;
				case 5:
					message.created = reader.string();
					break;
				case 6:
					message.updated = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.owner !== "") writer.tag(1, WireType.LengthDelimited).string(message.owner);
		if (message.application !== "") writer.tag(2, WireType.LengthDelimited).string(message.application);
		if (message.key !== "") writer.tag(3, WireType.LengthDelimited).string(message.key);
		if (message.value !== "") writer.tag(4, WireType.LengthDelimited).string(message.value);
		if (message.created !== "") writer.tag(5, WireType.LengthDelimited).string(message.created);
		if (message.updated !== "") writer.tag(6, WireType.LengthDelimited).string(message.updated);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.Property
*/
const Property = new Property$Type();
var GetPropertiesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetPropertiesRequest", [{
			no: 1,
			name: "application",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "keys",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.application = "";
		message.keys = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.application = reader.string();
					break;
				case 2:
					message.keys.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.application !== "") writer.tag(1, WireType.LengthDelimited).string(message.application);
		for (let i = 0; i < message.keys.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.keys[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetPropertiesRequest
*/
const GetPropertiesRequest = new GetPropertiesRequest$Type();
var GetPropertiesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetPropertiesResponse", [{
			no: 1,
			name: "properties",
			kind: "message",
			repeat: 2,
			T: () => Property
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.properties = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.properties.push(Property.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.properties.length; i++) Property.internalBinaryWrite(message.properties[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetPropertiesResponse
*/
const GetPropertiesResponse = new GetPropertiesResponse$Type();
var PropertyUpdate$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PropertyUpdate", [
			{
				no: 1,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "key",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "value",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.application = "";
		message.key = "";
		message.value = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.application = reader.string();
					break;
				case 2:
					message.key = reader.string();
					break;
				case 3:
					message.value = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.application !== "") writer.tag(1, WireType.LengthDelimited).string(message.application);
		if (message.key !== "") writer.tag(2, WireType.LengthDelimited).string(message.key);
		if (message.value !== "") writer.tag(3, WireType.LengthDelimited).string(message.value);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PropertyUpdate
*/
const PropertyUpdate = new PropertyUpdate$Type();
var SetPropertiesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.SetPropertiesRequest", [{
			no: 1,
			name: "properties",
			kind: "message",
			repeat: 2,
			T: () => PropertyUpdate
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.properties = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.properties.push(PropertyUpdate.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.properties.length; i++) PropertyUpdate.internalBinaryWrite(message.properties[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.SetPropertiesRequest
*/
const SetPropertiesRequest = new SetPropertiesRequest$Type();
var SetPropertiesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.SetPropertiesResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.SetPropertiesResponse
*/
const SetPropertiesResponse = new SetPropertiesResponse$Type();
var PropertyDelete$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PropertyDelete", [{
			no: 1,
			name: "application",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "key",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.application = "";
		message.key = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.application = reader.string();
					break;
				case 2:
					message.key = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.application !== "") writer.tag(1, WireType.LengthDelimited).string(message.application);
		if (message.key !== "") writer.tag(2, WireType.LengthDelimited).string(message.key);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PropertyDelete
*/
const PropertyDelete = new PropertyDelete$Type();
var DeletePropertiesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.DeletePropertiesRequest", [{
			no: 1,
			name: "properties",
			kind: "message",
			repeat: 2,
			T: () => PropertyDelete
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.properties = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.properties.push(PropertyDelete.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.properties.length; i++) PropertyDelete.internalBinaryWrite(message.properties[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.DeletePropertiesRequest
*/
const DeletePropertiesRequest = new DeletePropertiesRequest$Type();
var DeletePropertiesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.DeletePropertiesResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.DeletePropertiesResponse
*/
const DeletePropertiesResponse = new DeletePropertiesResponse$Type();
var PollEventLogRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PollEventLogRequest", [{
			no: 1,
			name: "after_id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.afterId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.afterId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.afterId !== 0n) writer.tag(1, WireType.Varint).int64(message.afterId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PollEventLogRequest
*/
const PollEventLogRequest = new PollEventLogRequest$Type();
var PollEventLogResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PollEventLogResponse", [{
			no: 1,
			name: "last_id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "entries",
			kind: "message",
			repeat: 2,
			T: () => EventLogEntry
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.lastId = 0n;
		message.entries = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.lastId = reader.int64().toBigInt();
					break;
				case 2:
					message.entries.push(EventLogEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.lastId !== 0n) writer.tag(1, WireType.Varint).int64(message.lastId);
		for (let i = 0; i < message.entries.length; i++) EventLogEntry.internalBinaryWrite(message.entries[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PollEventLogResponse
*/
const PollEventLogResponse = new PollEventLogResponse$Type();
var EventLogEntry$Type = class extends MessageType {
	constructor() {
		super("elephant.user.EventLogEntry", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "owner",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "type",
				kind: "enum",
				T: () => ["elephant.user.EventLogEntryType", EventLogEntryType]
			},
			{
				no: 4,
				name: "kind",
				kind: "enum",
				T: () => [
					"elephant.user.ResourceKind",
					ResourceKind,
					"RESOURCE_KIND_"
				]
			},
			{
				no: 5,
				name: "application",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "document_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "key",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 9,
				name: "updated_by",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "created",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.owner = "";
		message.type = 0;
		message.kind = 0;
		message.application = "";
		message.documentType = "";
		message.key = "";
		message.version = 0n;
		message.updatedBy = "";
		message.created = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.owner = reader.string();
					break;
				case 3:
					message.type = reader.int32();
					break;
				case 4:
					message.kind = reader.int32();
					break;
				case 5:
					message.application = reader.string();
					break;
				case 6:
					message.documentType = reader.string();
					break;
				case 7:
					message.key = reader.string();
					break;
				case 8:
					message.version = reader.int64().toBigInt();
					break;
				case 9:
					message.updatedBy = reader.string();
					break;
				case 10:
					message.created = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.owner !== "") writer.tag(2, WireType.LengthDelimited).string(message.owner);
		if (message.type !== 0) writer.tag(3, WireType.Varint).int32(message.type);
		if (message.kind !== 0) writer.tag(4, WireType.Varint).int32(message.kind);
		if (message.application !== "") writer.tag(5, WireType.LengthDelimited).string(message.application);
		if (message.documentType !== "") writer.tag(6, WireType.LengthDelimited).string(message.documentType);
		if (message.key !== "") writer.tag(7, WireType.LengthDelimited).string(message.key);
		if (message.version !== 0n) writer.tag(8, WireType.Varint).int64(message.version);
		if (message.updatedBy !== "") writer.tag(9, WireType.LengthDelimited).string(message.updatedBy);
		if (message.created !== "") writer.tag(10, WireType.LengthDelimited).string(message.created);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.EventLogEntry
*/
const EventLogEntry = new EventLogEntry$Type();
var PushMessageRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PushMessageRequest", [
			{
				no: 1,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "recipient",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "doc_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "doc_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "payload",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		message.recipient = "";
		message.docUuid = "";
		message.docType = "";
		message.payload = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.recipient = reader.string();
					break;
				case 3:
					message.docUuid = reader.string();
					break;
				case 4:
					message.docType = reader.string();
					break;
				case 5:
					this.binaryReadMap5(message.payload, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap5(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.user.PushMessageRequest.payload");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.recipient !== "") writer.tag(2, WireType.LengthDelimited).string(message.recipient);
		if (message.docUuid !== "") writer.tag(3, WireType.LengthDelimited).string(message.docUuid);
		if (message.docType !== "") writer.tag(4, WireType.LengthDelimited).string(message.docType);
		for (let k of globalThis.Object.keys(message.payload)) writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.payload[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PushMessageRequest
*/
const PushMessageRequest = new PushMessageRequest$Type();
var PushMessageResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PushMessageResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PushMessageResponse
*/
const PushMessageResponse = new PushMessageResponse$Type();
var PushInboxMessageRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PushInboxMessageRequest", [{
			no: 1,
			name: "recipient",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "payload",
			kind: "message",
			T: () => Document$1
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.recipient = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.recipient = reader.string();
					break;
				case 2:
					message.payload = Document$1.internalBinaryRead(reader, reader.uint32(), options, message.payload);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.recipient !== "") writer.tag(1, WireType.LengthDelimited).string(message.recipient);
		if (message.payload) Document$1.internalBinaryWrite(message.payload, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PushInboxMessageRequest
*/
const PushInboxMessageRequest = new PushInboxMessageRequest$Type();
var PushInboxMessageResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PushInboxMessageResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PushInboxMessageResponse
*/
const PushInboxMessageResponse = new PushInboxMessageResponse$Type();
var PollMessagesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PollMessagesRequest", [{
			no: 1,
			name: "after_id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.afterId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.afterId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.afterId !== 0n) writer.tag(1, WireType.Varint).int64(message.afterId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PollMessagesRequest
*/
const PollMessagesRequest = new PollMessagesRequest$Type();
var PollMessagesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PollMessagesResponse", [{
			no: 1,
			name: "last_id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "messages",
			kind: "message",
			repeat: 2,
			T: () => Message
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.lastId = 0n;
		message.messages = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.lastId = reader.int64().toBigInt();
					break;
				case 2:
					message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.lastId !== 0n) writer.tag(1, WireType.Varint).int64(message.lastId);
		for (let i = 0; i < message.messages.length; i++) Message.internalBinaryWrite(message.messages[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PollMessagesResponse
*/
const PollMessagesResponse = new PollMessagesResponse$Type();
var Message$Type = class extends MessageType {
	constructor() {
		super("elephant.user.Message", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "created_by",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "recipient",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "doc_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "doc_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "payload",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.type = "";
		message.created = "";
		message.createdBy = "";
		message.recipient = "";
		message.docUuid = "";
		message.docType = "";
		message.payload = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.created = reader.string();
					break;
				case 4:
					message.createdBy = reader.string();
					break;
				case 5:
					message.recipient = reader.string();
					break;
				case 6:
					message.docUuid = reader.string();
					break;
				case 7:
					message.docType = reader.string();
					break;
				case 8:
					this.binaryReadMap8(message.payload, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap8(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.user.Message.payload");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.created !== "") writer.tag(3, WireType.LengthDelimited).string(message.created);
		if (message.createdBy !== "") writer.tag(4, WireType.LengthDelimited).string(message.createdBy);
		if (message.recipient !== "") writer.tag(5, WireType.LengthDelimited).string(message.recipient);
		if (message.docUuid !== "") writer.tag(6, WireType.LengthDelimited).string(message.docUuid);
		if (message.docType !== "") writer.tag(7, WireType.LengthDelimited).string(message.docType);
		for (let k of globalThis.Object.keys(message.payload)) writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.payload[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.Message
*/
const Message = new Message$Type();
var PollInboxMessagesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PollInboxMessagesRequest", [{
			no: 1,
			name: "after_id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.afterId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.afterId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.afterId !== 0n) writer.tag(1, WireType.Varint).int64(message.afterId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PollInboxMessagesRequest
*/
const PollInboxMessagesRequest = new PollInboxMessagesRequest$Type();
var PollInboxMessagesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.PollInboxMessagesResponse", [{
			no: 1,
			name: "last_id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "messages",
			kind: "message",
			repeat: 2,
			T: () => InboxMessage
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.lastId = 0n;
		message.messages = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.lastId = reader.int64().toBigInt();
					break;
				case 2:
					message.messages.push(InboxMessage.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.lastId !== 0n) writer.tag(1, WireType.Varint).int64(message.lastId);
		for (let i = 0; i < message.messages.length; i++) InboxMessage.internalBinaryWrite(message.messages[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.PollInboxMessagesResponse
*/
const PollInboxMessagesResponse = new PollInboxMessagesResponse$Type();
var InboxMessage$Type = class extends MessageType {
	constructor() {
		super("elephant.user.InboxMessage", [
			{
				no: 1,
				name: "recipient",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "created_by",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "updated",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "is_read",
				kind: "scalar",
				T: 8
			},
			{
				no: 7,
				name: "payload",
				kind: "message",
				T: () => Document$1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.recipient = "";
		message.id = 0n;
		message.created = "";
		message.createdBy = "";
		message.updated = "";
		message.isRead = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.recipient = reader.string();
					break;
				case 2:
					message.id = reader.int64().toBigInt();
					break;
				case 3:
					message.created = reader.string();
					break;
				case 4:
					message.createdBy = reader.string();
					break;
				case 5:
					message.updated = reader.string();
					break;
				case 6:
					message.isRead = reader.bool();
					break;
				case 7:
					message.payload = Document$1.internalBinaryRead(reader, reader.uint32(), options, message.payload);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.recipient !== "") writer.tag(1, WireType.LengthDelimited).string(message.recipient);
		if (message.id !== 0n) writer.tag(2, WireType.Varint).int64(message.id);
		if (message.created !== "") writer.tag(3, WireType.LengthDelimited).string(message.created);
		if (message.createdBy !== "") writer.tag(4, WireType.LengthDelimited).string(message.createdBy);
		if (message.updated !== "") writer.tag(5, WireType.LengthDelimited).string(message.updated);
		if (message.isRead !== false) writer.tag(6, WireType.Varint).bool(message.isRead);
		if (message.payload) Document$1.internalBinaryWrite(message.payload, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.InboxMessage
*/
const InboxMessage = new InboxMessage$Type();
var ListInboxMessagesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ListInboxMessagesRequest", [{
			no: 1,
			name: "before_id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "size",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.beforeId = 0n;
		message.size = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.beforeId = reader.int64().toBigInt();
					break;
				case 2:
					message.size = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.beforeId !== 0n) writer.tag(1, WireType.Varint).int64(message.beforeId);
		if (message.size !== 0n) writer.tag(2, WireType.Varint).int64(message.size);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ListInboxMessagesRequest
*/
const ListInboxMessagesRequest = new ListInboxMessagesRequest$Type();
var ListInboxMessagesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ListInboxMessagesResponse", [
			{
				no: 1,
				name: "latest_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "earliest_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "messages",
				kind: "message",
				repeat: 2,
				T: () => InboxMessage
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.latestId = 0n;
		message.earliestId = 0n;
		message.messages = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.latestId = reader.int64().toBigInt();
					break;
				case 2:
					message.earliestId = reader.int64().toBigInt();
					break;
				case 3:
					message.messages.push(InboxMessage.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.latestId !== 0n) writer.tag(1, WireType.Varint).int64(message.latestId);
		if (message.earliestId !== 0n) writer.tag(2, WireType.Varint).int64(message.earliestId);
		for (let i = 0; i < message.messages.length; i++) InboxMessage.internalBinaryWrite(message.messages[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ListInboxMessagesResponse
*/
const ListInboxMessagesResponse = new ListInboxMessagesResponse$Type();
var UpdateInboxMessageRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.UpdateInboxMessageRequest", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "is_read",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.isRead = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.isRead = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.isRead !== false) writer.tag(2, WireType.Varint).bool(message.isRead);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.UpdateInboxMessageRequest
*/
const UpdateInboxMessageRequest = new UpdateInboxMessageRequest$Type();
var UpdateInboxMessageResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.UpdateInboxMessageResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.UpdateInboxMessageResponse
*/
const UpdateInboxMessageResponse = new UpdateInboxMessageResponse$Type();
var DeleteInboxMessageRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.DeleteInboxMessageRequest", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.DeleteInboxMessageRequest
*/
const DeleteInboxMessageRequest = new DeleteInboxMessageRequest$Type();
var DeleteInboxMessageResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.DeleteInboxMessageResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.DeleteInboxMessageResponse
*/
const DeleteInboxMessageResponse = new DeleteInboxMessageResponse$Type();
var ConfigGenerationSchema$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ConfigGenerationSchema", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "spec",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "usage",
				kind: "enum",
				T: () => [
					"elephant.user.SchemaUsage",
					SchemaUsage,
					"SCHEMA_USAGE_"
				]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		message.spec = "";
		message.usage = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.string();
					break;
				case 3:
					message.spec = reader.string();
					break;
				case 4:
					message.usage = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(2, WireType.LengthDelimited).string(message.version);
		if (message.spec !== "") writer.tag(3, WireType.LengthDelimited).string(message.spec);
		if (message.usage !== 0) writer.tag(4, WireType.Varint).int32(message.usage);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ConfigGenerationSchema
*/
const ConfigGenerationSchema = new ConfigGenerationSchema$Type();
var ConfigGeneration$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ConfigGeneration", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "active",
				kind: "scalar",
				T: 8
			},
			{
				no: 4,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "activated",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "schemas",
				kind: "message",
				repeat: 2,
				T: () => ConfigGenerationSchema
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.description = "";
		message.active = false;
		message.created = "";
		message.activated = "";
		message.schemas = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.description = reader.string();
					break;
				case 3:
					message.active = reader.bool();
					break;
				case 4:
					message.created = reader.string();
					break;
				case 5:
					message.activated = reader.string();
					break;
				case 6:
					message.schemas.push(ConfigGenerationSchema.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.description !== "") writer.tag(2, WireType.LengthDelimited).string(message.description);
		if (message.active !== false) writer.tag(3, WireType.Varint).bool(message.active);
		if (message.created !== "") writer.tag(4, WireType.LengthDelimited).string(message.created);
		if (message.activated !== "") writer.tag(5, WireType.LengthDelimited).string(message.activated);
		for (let i = 0; i < message.schemas.length; i++) ConfigGenerationSchema.internalBinaryWrite(message.schemas[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ConfigGeneration
*/
const ConfigGeneration = new ConfigGeneration$Type();
var RegisterConfigGenerationRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.RegisterConfigGenerationRequest", [
			{
				no: 1,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "schemas",
				kind: "message",
				repeat: 2,
				T: () => ConfigGenerationSchema
			},
			{
				no: 3,
				name: "activate",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.description = "";
		message.schemas = [];
		message.activate = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.description = reader.string();
					break;
				case 2:
					message.schemas.push(ConfigGenerationSchema.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 3:
					message.activate = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.description !== "") writer.tag(1, WireType.LengthDelimited).string(message.description);
		for (let i = 0; i < message.schemas.length; i++) ConfigGenerationSchema.internalBinaryWrite(message.schemas[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.activate !== false) writer.tag(3, WireType.Varint).bool(message.activate);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.RegisterConfigGenerationRequest
*/
const RegisterConfigGenerationRequest = new RegisterConfigGenerationRequest$Type();
var RegisterConfigGenerationResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.RegisterConfigGenerationResponse", [{
			no: 1,
			name: "generation",
			kind: "message",
			T: () => ConfigGeneration
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.generation = ConfigGeneration.internalBinaryRead(reader, reader.uint32(), options, message.generation);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.generation) ConfigGeneration.internalBinaryWrite(message.generation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.RegisterConfigGenerationResponse
*/
const RegisterConfigGenerationResponse = new RegisterConfigGenerationResponse$Type();
var ActivateConfigGenerationRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ActivateConfigGenerationRequest", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ActivateConfigGenerationRequest
*/
const ActivateConfigGenerationRequest = new ActivateConfigGenerationRequest$Type();
var ActivateConfigGenerationResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ActivateConfigGenerationResponse", [{
			no: 1,
			name: "generation",
			kind: "message",
			T: () => ConfigGeneration
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.generation = ConfigGeneration.internalBinaryRead(reader, reader.uint32(), options, message.generation);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.generation) ConfigGeneration.internalBinaryWrite(message.generation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ActivateConfigGenerationResponse
*/
const ActivateConfigGenerationResponse = new ActivateConfigGenerationResponse$Type();
var GetActiveConfigGenerationRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetActiveConfigGenerationRequest", [
			{
				no: 1,
				name: "wait_seconds",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "known_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "only_changed",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.waitSeconds = 0n;
		message.knownId = 0n;
		message.onlyChanged = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.waitSeconds = reader.int64().toBigInt();
					break;
				case 2:
					message.knownId = reader.int64().toBigInt();
					break;
				case 3:
					message.onlyChanged = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.waitSeconds !== 0n) writer.tag(1, WireType.Varint).int64(message.waitSeconds);
		if (message.knownId !== 0n) writer.tag(2, WireType.Varint).int64(message.knownId);
		if (message.onlyChanged !== false) writer.tag(3, WireType.Varint).bool(message.onlyChanged);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetActiveConfigGenerationRequest
*/
const GetActiveConfigGenerationRequest = new GetActiveConfigGenerationRequest$Type();
var GetActiveConfigGenerationResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetActiveConfigGenerationResponse", [{
			no: 1,
			name: "generation",
			kind: "message",
			T: () => ConfigGeneration
		}, {
			no: 2,
			name: "unchanged",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.unchanged = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.generation = ConfigGeneration.internalBinaryRead(reader, reader.uint32(), options, message.generation);
					break;
				case 2:
					message.unchanged = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.generation) ConfigGeneration.internalBinaryWrite(message.generation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.unchanged !== false) writer.tag(2, WireType.Varint).bool(message.unchanged);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetActiveConfigGenerationResponse
*/
const GetActiveConfigGenerationResponse = new GetActiveConfigGenerationResponse$Type();
var ListConfigGenerationsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ListConfigGenerationsRequest", [{
			no: 1,
			name: "before",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "page_size",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.before = 0n;
		message.pageSize = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.before = reader.int64().toBigInt();
					break;
				case 2:
					message.pageSize = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.before !== 0n) writer.tag(1, WireType.Varint).int64(message.before);
		if (message.pageSize !== 0n) writer.tag(2, WireType.Varint).int64(message.pageSize);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ListConfigGenerationsRequest
*/
const ListConfigGenerationsRequest = new ListConfigGenerationsRequest$Type();
var ListConfigGenerationsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.ListConfigGenerationsResponse", [{
			no: 1,
			name: "generations",
			kind: "message",
			repeat: 2,
			T: () => ConfigGeneration
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.generations = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.generations.push(ConfigGeneration.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.generations.length; i++) ConfigGeneration.internalBinaryWrite(message.generations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.ListConfigGenerationsResponse
*/
const ListConfigGenerationsResponse = new ListConfigGenerationsResponse$Type();
var GetSchemaRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetSchemaRequest", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "version",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(2, WireType.LengthDelimited).string(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetSchemaRequest
*/
const GetSchemaRequest = new GetSchemaRequest$Type();
var GetSchemaResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetSchemaResponse", [
			{
				no: 1,
				name: "version",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "spec",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "usage",
				kind: "enum",
				T: () => [
					"elephant.user.SchemaUsage",
					SchemaUsage,
					"SCHEMA_USAGE_"
				]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = "";
		message.spec = "";
		message.usage = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.version = reader.string();
					break;
				case 2:
					message.spec = reader.string();
					break;
				case 3:
					message.usage = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.version !== "") writer.tag(1, WireType.LengthDelimited).string(message.version);
		if (message.spec !== "") writer.tag(2, WireType.LengthDelimited).string(message.spec);
		if (message.usage !== 0) writer.tag(3, WireType.Varint).int32(message.usage);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetSchemaResponse
*/
const GetSchemaResponse = new GetSchemaResponse$Type();
var Deprecation$Type = class extends MessageType {
	constructor() {
		super("elephant.user.Deprecation", [{
			no: 1,
			name: "label",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "enforced",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.label = "";
		message.enforced = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.label = reader.string();
					break;
				case 2:
					message.enforced = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.label !== "") writer.tag(1, WireType.LengthDelimited).string(message.label);
		if (message.enforced !== false) writer.tag(2, WireType.Varint).bool(message.enforced);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.Deprecation
*/
const Deprecation = new Deprecation$Type();
var GetDeprecationsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetDeprecationsRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetDeprecationsRequest
*/
const GetDeprecationsRequest = new GetDeprecationsRequest$Type();
var GetDeprecationsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.GetDeprecationsResponse", [{
			no: 1,
			name: "deprecations",
			kind: "message",
			repeat: 2,
			T: () => Deprecation
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.deprecations = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.deprecations.push(Deprecation.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.deprecations.length; i++) Deprecation.internalBinaryWrite(message.deprecations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.GetDeprecationsResponse
*/
const GetDeprecationsResponse = new GetDeprecationsResponse$Type();
var UpdateDeprecationRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.user.UpdateDeprecationRequest", [{
			no: 1,
			name: "deprecation",
			kind: "message",
			T: () => Deprecation
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.deprecation = Deprecation.internalBinaryRead(reader, reader.uint32(), options, message.deprecation);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.deprecation) Deprecation.internalBinaryWrite(message.deprecation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.UpdateDeprecationRequest
*/
const UpdateDeprecationRequest = new UpdateDeprecationRequest$Type();
var UpdateDeprecationResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.user.UpdateDeprecationResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.user.UpdateDeprecationResponse
*/
const UpdateDeprecationResponse = new UpdateDeprecationResponse$Type();
/**
* @generated ServiceType for protobuf service elephant.user.Settings
*/
const Settings = new ServiceType("elephant.user.Settings", [
	{
		name: "GetDocument",
		options: {},
		I: GetDocumentRequest,
		O: GetDocumentResponse
	},
	{
		name: "ListDocuments",
		options: {},
		I: ListDocumentsRequest,
		O: ListDocumentsResponse
	},
	{
		name: "UpdateDocument",
		options: {},
		I: UpdateDocumentRequest,
		O: UpdateDocumentResponse
	},
	{
		name: "DeleteDocument",
		options: {},
		I: DeleteDocumentRequest,
		O: DeleteDocumentResponse
	},
	{
		name: "GetProperties",
		options: {},
		I: GetPropertiesRequest,
		O: GetPropertiesResponse
	},
	{
		name: "SetProperties",
		options: {},
		I: SetPropertiesRequest,
		O: SetPropertiesResponse
	},
	{
		name: "DeleteProperties",
		options: {},
		I: DeletePropertiesRequest,
		O: DeletePropertiesResponse
	},
	{
		name: "PollEventLog",
		options: {},
		I: PollEventLogRequest,
		O: PollEventLogResponse
	}
]);
/**
* @generated ServiceType for protobuf service elephant.user.Messages
*/
const Messages = new ServiceType("elephant.user.Messages", [
	{
		name: "PushMessage",
		options: {},
		I: PushMessageRequest,
		O: PushMessageResponse
	},
	{
		name: "PushInboxMessage",
		options: {},
		I: PushInboxMessageRequest,
		O: PushInboxMessageResponse
	},
	{
		name: "PollMessages",
		options: {},
		I: PollMessagesRequest,
		O: PollMessagesResponse
	},
	{
		name: "PollInboxMessages",
		options: {},
		I: PollInboxMessagesRequest,
		O: PollInboxMessagesResponse
	},
	{
		name: "ListInboxMessages",
		options: {},
		I: ListInboxMessagesRequest,
		O: ListInboxMessagesResponse
	},
	{
		name: "UpdateInboxMessage",
		options: {},
		I: UpdateInboxMessageRequest,
		O: UpdateInboxMessageResponse
	},
	{
		name: "DeleteInboxMessage",
		options: {},
		I: DeleteInboxMessageRequest,
		O: DeleteInboxMessageResponse
	}
]);
/**
* @generated ServiceType for protobuf service elephant.user.Configuration
*/
const Configuration = new ServiceType("elephant.user.Configuration", [
	{
		name: "RegisterConfigGeneration",
		options: {},
		I: RegisterConfigGenerationRequest,
		O: RegisterConfigGenerationResponse
	},
	{
		name: "ActivateConfigGeneration",
		options: {},
		I: ActivateConfigGenerationRequest,
		O: ActivateConfigGenerationResponse
	},
	{
		name: "GetActiveConfigGeneration",
		options: {},
		I: GetActiveConfigGenerationRequest,
		O: GetActiveConfigGenerationResponse
	},
	{
		name: "ListConfigGenerations",
		options: {},
		I: ListConfigGenerationsRequest,
		O: ListConfigGenerationsResponse
	},
	{
		name: "GetSchema",
		options: {},
		I: GetSchemaRequest,
		O: GetSchemaResponse
	},
	{
		name: "GetDeprecations",
		options: {},
		I: GetDeprecationsRequest,
		O: GetDeprecationsResponse
	},
	{
		name: "UpdateDeprecation",
		options: {},
		I: UpdateDeprecationRequest,
		O: UpdateDeprecationResponse
	}
]);
//#endregion
//#region src/user/service.client.ts
/**
* Settings service manages configuration for authenticated users.
*
* All methods in this service rely on the `sub` claim from the
* authentication (bearer) token to identify the target user.
*
* @generated from protobuf service elephant.user.Settings
*/
var SettingsClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Settings.typeName;
		this.methods = Settings.methods;
		this.options = Settings.options;
	}
	/**
	* Gets a specific document for the authenticated user.
	*
	* @generated from protobuf rpc: GetDocument
	*/
	getDocument(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Lists documents for the authenticated user.
	*
	* @generated from protobuf rpc: ListDocuments
	*/
	listDocuments(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Updates an existing or creates a new document for the authenticated user.
	*
	* @generated from protobuf rpc: UpdateDocument
	*/
	updateDocument(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Deletes a document for the authenticated user.
	*
	* @generated from protobuf rpc: DeleteDocument
	*/
	deleteDocument(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Gets properties for the authenticated user.
	*
	* @generated from protobuf rpc: GetProperties
	*/
	getProperties(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Sets or updates properties for the authenticated user.
	*
	* @generated from protobuf rpc: SetProperties
	*/
	setProperties(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Deletes properties for the authenticated user.
	*
	* @generated from protobuf rpc: DeleteProperties
	*/
	deleteProperties(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Polls for a stream of changes (creates, updates, deletes)
	* for both documents and properties for the authenticated user.
	*
	* @generated from protobuf rpc: PollEventLog
	*/
	pollEventLog(input, options) {
		const method = this.methods[7], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* @generated from protobuf service elephant.user.Messages
*/
var MessagesClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Messages.typeName;
		this.methods = Messages.methods;
		this.options = Messages.options;
	}
	/**
	* Pushes a new message to a recipient.
	*
	* @generated from protobuf rpc: PushMessage
	*/
	pushMessage(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Pushes a new inbox message to a recipient.
	*
	* @generated from protobuf rpc: PushInboxMessage
	*/
	pushInboxMessage(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Polls for new messages for a recipient.
	*
	* @generated from protobuf rpc: PollMessages
	*/
	pollMessages(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Polls for new inbox messages for a recipient.
	*
	* @generated from protobuf rpc: PollInboxMessages
	*/
	pollInboxMessages(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Lists all inbox messages for a recipient.
	*
	* @generated from protobuf rpc: ListInboxMessages
	*/
	listInboxMessages(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Updates an existing inbox message.
	*
	* @generated from protobuf rpc: UpdateInboxMessage
	*/
	updateInboxMessage(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Deletes an inbox message.
	*
	* @generated from protobuf rpc: DeleteInboxMessage
	*/
	deleteInboxMessage(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* Configuration manages the revisor schemas that the user service
* validates settings documents and inbox messages against. Schemas are
* grouped into config generations that are registered and switched
* atomically.
*
* @generated from protobuf service elephant.user.Configuration
*/
var ConfigurationClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Configuration.typeName;
		this.methods = Configuration.methods;
		this.options = Configuration.options;
	}
	/**
	* Registers a new config generation. Registration is idempotent: a
	* generation containing the same set of schemas returns the already
	* registered generation (its description is left unchanged). If
	* activate is set and the matched generation is inactive it will be
	* activated.
	*
	* @generated from protobuf rpc: RegisterConfigGeneration
	*/
	registerConfigGeneration(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Activates a registered config generation, deactivating the
	* previously active generation.
	*
	* @generated from protobuf rpc: ActivateConfigGeneration
	*/
	activateConfigGeneration(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Gets the currently active config generation. Supports long-polling
	* for generation changes.
	*
	* @generated from protobuf rpc: GetActiveConfigGeneration
	*/
	getActiveConfigGeneration(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Lists registered config generations, newest first.
	*
	* @generated from protobuf rpc: ListConfigGenerations
	*/
	listConfigGenerations(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Gets a stored schema.
	*
	* @generated from protobuf rpc: GetSchema
	*/
	getSchema(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Lists the deprecation statuses.
	*
	* @generated from protobuf rpc: GetDeprecations
	*/
	getDeprecations(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Creates or updates a deprecation status.
	*
	* @generated from protobuf rpc: UpdateDeprecation
	*/
	updateDeprecation(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
//#endregion
export { ActivateConfigGenerationRequest, ActivateConfigGenerationResponse, ConfigGeneration, ConfigGenerationSchema, Configuration, ConfigurationClient, DeleteDocumentRequest, DeleteDocumentResponse, DeleteInboxMessageRequest, DeleteInboxMessageResponse, DeletePropertiesRequest, DeletePropertiesResponse, Deprecation, Document, EventLogEntry, EventLogEntryType, GetActiveConfigGenerationRequest, GetActiveConfigGenerationResponse, GetDeprecationsRequest, GetDeprecationsResponse, GetDocumentRequest, GetDocumentResponse, GetPropertiesRequest, GetPropertiesResponse, GetSchemaRequest, GetSchemaResponse, InboxMessage, ListConfigGenerationsRequest, ListConfigGenerationsResponse, ListDocumentsRequest, ListDocumentsResponse, ListInboxMessagesRequest, ListInboxMessagesResponse, Message, Messages, MessagesClient, PollEventLogRequest, PollEventLogResponse, PollInboxMessagesRequest, PollInboxMessagesResponse, PollMessagesRequest, PollMessagesResponse, Property, PropertyDelete, PropertyUpdate, PushInboxMessageRequest, PushInboxMessageResponse, PushMessageRequest, PushMessageResponse, RegisterConfigGenerationRequest, RegisterConfigGenerationResponse, ResourceKind, SchemaUsage, SetPropertiesRequest, SetPropertiesResponse, Settings, SettingsClient, UpdateDeprecationRequest, UpdateDeprecationResponse, UpdateDocumentRequest, UpdateDocumentResponse, UpdateInboxMessageRequest, UpdateInboxMessageResponse };
